/**
 * SOLID Review
 * S — Strong. One use case: the sign-up form — registered, then on to the code screen.
 * O — Strong. The round trip runs it; what is allowed is the Domain's.
 * L — Strong. Implements its use-case role and the round trip's three strategies exactly.
 * I — Strong. `execute`, and the three strategies the round trip asks for.
 * D — Strong. The decisions and auth-server ports and the round trip, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { IPropsClientInput } from '../../domain/ports/schemas/ClientChanges';
import type { ICommandSignUp, ICommandSignedUp, IPayloadSignUp } from '../../domain/ports/schemas/AuthMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { TServerRoundTrip, TAnsweredVoid } from '../shared/ServerRoundTrip';
import type { IConfigDepAuth } from './IConfigDepAuth';

/** The email screen in sign-up mode (FE3): register, then on to the code screen. */
export class SignUpUseCase implements IUseCase<ICommandSignUp, TPortOutcome>, TServerRoundTrip<IPropsClientInput, ICommandSignUp, IPayloadSignUp, TAnsweredVoid> {
  constructor(private readonly deps: IConfigDepAuth) {}

  execute(ctx: IContextRequest, command: ICommandSignUp): Promise<TPortOutcome> {
    return this.deps.trip.run(ctx, command, this);
  }

  plan(ctx: IContextRequest, input: IPropsClientInput, command: ICommandSignUp) {
    return this.deps.decisions.planSignUp(ctx, input, command);
  }

  send(ctx: IContextRequest, plan: IPayloadSignUp) {
    return this.deps.auth.register(ctx, plan);
  }

  answer(ctx: IContextRequest, input: IPropsClientInput, plan: IPayloadSignUp) {
    const signedUp: ICommandSignedUp = { email: plan.email };
    return this.deps.decisions.signedUp(ctx, input, signedUp);
  }
}
